<section class="mt-5 pt-5 video-top">
    <div class="container">
        <div class="content-container">
            <div class="video-chat-container">
                <div class="video-container h-100">
                    <div class="row">
                        <div class="col-md-6 video-cards">
                            <p class="text-center remote-video-text h-100">Connecting....</p>
                            <video autoplay id="remote-video" class="w-100 d-none"></video>
                        </div>
                        <div class="col-md-6 video-cards">
                            <video autoplay muted="true" class="w-100" id="local-video"></video>
                        </div>
                    </div>


                    <div class="row align-items-center w-100 justify-content-center pt-3">
                        <div class="d-flex align-items-center greenBackgroundColor px-3 py-2">
                            <a (click)="fullScreen()">
                                <i class="fa fa-arrows-alt mr-3 whiteColor" style="font-size: 1.8rem;"></i>
                            </a>
                            <a (click)="flipCamera()">
                                <img loading="lazy" src="{{videoCdnUrl}}images/flip.svg" height="35" width="35" class="mr-3"
                                    id="disconnetCall" alt="end-call-icon">
                            </a>
                            <a (click)="muteVideo()">
                                <i class="fa fa-microphone mute-audio mr-3 whiteColor" style="font-size: 1.8rem;"></i>
                            </a>
                            <a (click)="disconnect()">
                                <img loading="lazy" src="{{videoCdnUrl}}images/end-call-icon.jpg" height="35" width="35"
                                    id="disconnetCall" alt="end-call-icon">
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <div class="d-none thank-msg mt-5 mb-5 text-center">
                <img loading="lazy" src="{{videoCdnUrl}}images/right.svg" height="50" width="50" alt="right">
                <h3 class="mt-3">Thank you for attending video consultation.</h3>
            </div>

        </div>
    </div>
</section>

<div class="modal fade" id="ModalCenterAlert" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-body">
                <button type="button" class="close ml-auto" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                <div class="text-center p-3 pt-4" id="messageText">
                    <p>Are you sure you want to disconnect this call?</p>
                </div>
                <div class="w-100 text-center">
                    <button type="button" id="disconnectCall" class="btn btn-outline-primary mr-3 btn-border-radius"
                        data-dismiss="modal" aria-label="Close">Yes</button>
                    <button type="button" class="btn btn-outline-primary btn-border-radius" data-dismiss="modal"
                        aria-label="Close">No</button>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="ModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-body">
                <button type="button" class="close ml-auto" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                <div class="text-center p-3 pt-4" id="messageText">
                    <div *ngIf="isSuccess">
                        <img loading="lazy" src="{{videoCdnUrl}}images/right.svg" height="50" width="50" alt="right">
                        <p class="primaryColor">Success</p>
                        <p>Thank you for attending video consultation.</p>
                    </div>
                </div>
                <div class="w-100 text-center">
                    <button type="button" class="btn btn-outline-primary btn-border-radius" (click)="close()"
                        aria-label="Close">OK</button>
                </div>
            </div>
        </div>
    </div>
</div>